import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { 
    IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

import { MarvDateToStringPipe } from '@marv/pipes';
import { MarvSubItemComponent } from '@marv/components';
import { AlertMessage, AlertMessageType, AlertMessageStatus } from '@app/models';

export class AlertItem {
    type: AlertMessageType;
    title: string;
    body: string;
    date: Date;
    status: AlertMessageStatus;
    isOpened: boolean = false;
    
    static FromAlertMessage(alertMessage: AlertMessage): AlertItem{
        let alertItem = new AlertItem();
        alertItem.type = alertMessage.type;
        alertItem.title = alertMessage.title;
        alertItem.body = alertMessage.body;
        alertItem.date = alertMessage.date;
        alertItem.status = alertMessage.status;
        return alertItem;
    }
    
}

@Component({
    selector: 'app-alert-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    imports: [IonIcon, TranslatePipe, MarvDateToStringPipe, forwardRef(() => MarvSubItemComponent)]
})
export class AlertItemComponent  implements OnInit {

    @Input({alias : 'alert', required : true}) alert: AlertItem;

    AlertMessageStatus = AlertMessageStatus;

    constructor() { }

    ngOnInit() {}
    
    toggleAlertMessage(){
        this.alert.isOpened = !this.alert.isOpened;
    }

}
